import React from 'react';
//import CompanyLogo from '../CompanyLogo/CompanyLogo.png';
//import QRCODE from '../qr/QRCODE.png';

const SaleReturnPrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px',
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        fontFamily: 'Arial',

    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };

    const cellStyleP = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };
    const cellStyleNew = {
        border: '1px solid #000',
        padding: '0px',
        // marginTop: '15px',
        // height: '20px'
        marginTop: '10px',
        //height: '10px'
    };

    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                            {/* Logo Section */}
                            {/* <div style={{ width: '20%', textAlign: 'left' }}>
                                <img
                                    src={CompanyLogo}
                                    alt="Company Logo"
                                    style={{
                                        maxHeight: '50px',
                                        width: 'auto',
                                        height: 'auto',
                                        marginBottom: '5px',
                                    }}
                                />
                            </div> */}
                            {/* Company Info Section */}
                            <div style={{ width: '40%', textAlign: 'left', lineHeight: '1.5', marginLeft: '20%' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '18px' }}>{labelData.SalePrint.CompanyName}</div>
                                <div style={{ fontWeight: 'normal', fontSize: '14px' }}>{labelData.SalePrint.CompanyAddressLine}</div>
                                {/* <div style={{fontWeight:'normal',fontSize:'14px'}}>{labelData.SalePrint.CompanyAddressLine2}</div> */}
                                <div style={{ fontWeight: 'normal', fontSize: '14px' }}>{labelData.SalePrint.CompanyContactNumber1}</div>
                                <div style={{ fontWeight: 'normal', fontSize: '14px' }}>{labelData.SalePrint.CompanyEmail}</div>
                                <div style={{ fontWeight: 'normal', fontSize: '14px' }}>GST No: {labelData.SalePrint.CompanyGSTNumber}</div>
                            </div>
                            {/* Contact Info Section */}
                            <div style={{ width: '40%', textAlign: 'right', fontSize: '12px', lineHeight: '1.5', fontWeight: 'normal', marginTop: '-17px' }}>
                                {/* <div>CONTACT NO 1: </div>
                                <div>CONTACT NO 2: </div> */}
                                {/* <div>Thrissur: 0487-2441802, +919497714427</div>
                                <div>Mobile: +919447167852, +919447087852</div>
                                <div>Accounts: +919446007858</div>
                                <div>Office: +919446007856</div> */}
                            </div>
                        </div>
                        <div
                            style={{
                                textAlign: 'center',
                                marginTop: '1px',
                                marginBottom: '0px',
                                border: '1px solid black',
                                padding: '10px', // Added padding for spacing
                            }}
                        >
                            {/* Top row with State and Reverse Charge */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '5px' }}>
                                <div style={{ fontWeight: 'normal', marginLeft: '5px', textAlign: 'left' }}>
                                    State : Kerala - 32
                                    <div>Reverse Charge : NO</div>
                                </div>

                                <div style={{ fontWeight: 'normal', marginRight: '5px', textAlign: 'right', fontWeight: 'bold' }}>

                                    <div>Invoice Date <span style={{ marginLeft: '3px' }}>:</span> {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}</div>
                                    <div>Invoice No <span style={{ marginLeft: '12px' }}>:</span> {labelData.SalePrint.InvoiceNo}</div>
                                </div>

                            </div>

                            {/* Centered TAX INVOICE */}
                            <div style={{ margin: '-15px 0 5px 0' }}>
                                <b style={{ fontSize: '16px', display: 'block' }}>TAX INVOICE</b>
                                <b style={{ fontSize: '14px' }}>{labelData.SalePrint.PaymentMode}</b>
                            </div>


                        </div>

                    </div>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan="12" style={{ border: '1px solid black', padding: '5px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                        <div style={{ textAlign: 'left', marginLeft: '5px', marginBottom: '0px' }}>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '2px' }}>
                                                IRN No <span style={{ marginLeft: '50px' }}>:</span>  <span style={{ marginLeft: '5px' }}>{labelData.SalePrint.IRNNo}</span>
                                            </div>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '4px' }}>
                                                Ack No <span style={{ marginLeft: '50px' }}>:</span>  <span style={{ marginLeft: '5px' }}>{labelData.SalePrint.AckNo}</span>
                                            </div>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '6px' }}>
                                                Ack Date <span style={{ marginLeft: '40px' }}>:</span>
                                                <span style={{ marginLeft: '5px' }}>{new Date(labelData.SalePrint.AckDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}</span>
                                            </div>
                                            {/* <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '6px' }}>
                                                e-WAY Bill No <span style={{ marginLeft: '14px' }}>:</span> <span style={{ marginLeft: '5px' }}>{labelData.SalePrint.eWAYBillNo}</span>
                                            </div>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '6px' }}>
                                                e-WAY Bill Date <span style={{ marginLeft: '2px' }}>:</span>
                                                <span style={{ marginLeft: '5px' }}>{new Date(labelData.SalePrint.eWAYBillDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}</span>
                                            </div> */}

                                            <div style={{ display: 'flex', fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '6px' }}>
                                                <div style={{ marginRight: '20px' }}>
                                                    e-WAY Bill No <span style={{ marginLeft: '14px' }}>:</span>
                                                    <span style={{ marginLeft: '5px' }}>{labelData.SalePrint.eWAYBillNo}</span>
                                                </div>
                                                <div>
                                                    e-WAY Bill Date <span style={{ marginLeft: '2px' }}>:</span>
                                                    <span style={{ marginLeft: '5px' }}>
                                                        {new Date(labelData.SalePrint.eWAYBillDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        })}
                                                    </span>
                                                </div>
                                            </div>


                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '5px' }}>
                                                Parcel Name  : {labelData.SalePrint.Placeofdelivery}
                                            </div>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '5px' }}>
                                                Place of delivery : {labelData.SalePrint.Placeofdelivery}VehicleNo
                                            </div>
                                            <div style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '5px', marginTop: '5px' }}>
                                                Vehicle No :{labelData.SalePrint.VehicleNo}
                                            </div>

                                        </div>
                                        {/* <div style={{ textAlign: 'left', marginLeft: '5px', marginTop: '2px' }}>
                                            <img src={QRCODE} alt="QRCODE" style={{ maxHeight: '100%', margin: '0 auto', width: '100%', marginTop: '-2.10%px' }} />
                                        </div> */}
                                    </div>
                                </td>
                            </tr>


                            <tr>
                                <td style={{ ...cellStyle, width: '52%', textAlign: 'left', maxHeight: '15%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '-5px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Customer Name & Address</h6>

                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', marginTop: '0.50%' }}>{labelData.SalePrint.CustomerName}</h6>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.CustomerAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}

                                    {labelData.SalePrint.CustomerContactNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>TEL : {labelData.SalePrint.CustomerContactNumber} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Contact Number: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerEmail ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>Email : {labelData.SalePrint.CustomerEmail}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Customer Email: Not Available</h6>
                                    )}
                                    {labelData.SalePrint.CustomerGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}> GST NO:{labelData.SalePrint.CustomerGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Not Available</h6>
                                    )}

                                </td>

                                <td style={{ ...cellStyle, width: '50%', textAlign: 'left', maxHeight: '15%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '15px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>SHIP TO</h6>

                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', marginTop: '0.90%', fontWeight: 'bold' }}>{labelData.SalePrint.ShipTo}</h6>
                                    {labelData.SalePrint.ShipToAddress1 ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.ShipToAddress1} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}
                                    {labelData.SalePrint.ShipToAddress2 ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>{labelData.SalePrint.ShipToAddress2} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}></h6>
                                    )}

                                    {labelData.SalePrint.ShipToLocation ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}> {labelData.SalePrint.ShipToLocation}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Location : Not Available</h6>
                                    )}
                                    {labelData.SalePrint.ShipGSTNo ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}>GST NO : {labelData.SalePrint.ShipGSTNo}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>GST NO : Not Available</h6>
                                    )}
                                    {labelData.SalePrint.ShipToPincode ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal', marginTop: '1%' }}> {labelData.SalePrint.ShipToPincode}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Pin Code: Not Available</h6>
                                    )}

                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <td style={{ ...cellStyle, width: '8%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>HSN Code</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '20%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>Description</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>QTY</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>Rate</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>Disc</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '12%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>Rate After Disc</h6>
                                    {/* <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>After Disc</h6> */}
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>GST %</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>CGST ₹</h6>
                                </td>
                                {/* <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>SGST%</h6>
                                </td> */}
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>SGST ₹</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>IGST ₹</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '15%' }}>
                                    <h6 style={{ marginTop: '10px', marginBottom: '2px' }}>Total ₹</h6>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {labelData && labelData.SalePrintItems.map((record, index) => {
                                const isLastRecord = index === labelData.SalePrintItems.length - 1;
                                const isFirstRecord = index === 0;
                                return (
                                    <tr key={index} style={{ height: '20px' }}>

                                        <td style={{ ...cellStyleP, height: '20px', width: '8%', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.HSNCode}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '20%', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.ItemName}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'right',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>

                                                    {record.Quantity !== 0 ? record.Quantity : ''}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '10%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'right',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.Rate !== 0 ? record.Rate : ''}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'right',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.DiscountAmount !== 0 ? record.DiscountAmount : ''}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '9%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'right',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.RateAfterDiscount !== 0 ? record.RateAfterDiscount : ''}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'right',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {(record.GSTRate) !== 0 ? (record.GSTRate) : ''}
                                                </label>
                                            </div>
                                        </td>

                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {(record.CGSTAmount) !== 0 ? (record.CGSTAmount) : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, height: '20px', width: '7%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {(record.SGSTAmount) !== 0 ? (record.SGSTAmount) : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, height: '20px', width: '5%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>

                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, height: '20px', width: '15%', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.TotalAmount !== 0 ? record.TotalAmount : ''}
                                            </label>
                                        </td>

                                    </tr>

                                );
                            })}

                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan="12" style={{ border: '1px solid black', padding: '5px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '10px', marginLeft: '0%' }}></div>
                                        <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '10px', marginLeft: '25%' }}>
                                            {labelData.SalePrint.TotalQuantity != null
                                                ? labelData.SalePrint.TotalQuantity.toFixed(2)
                                                : '0.00'}
                                        </div>
                                        <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '10px', marginLeft: '33%' }}>
                                            {labelData.SalePrint.CGSTAmount != null
                                                ? labelData.SalePrint.CGSTAmount.toFixed(2)
                                                : '0.00'}
                                        </div>
                                        <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '10px', marginLeft: '-15px' }}>
                                            {labelData.SalePrint.SGSTAmount != null
                                                ? labelData.SalePrint.SGSTAmount.toFixed(2)
                                                : '0.00'}
                                        </div>
                                        <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '10px', marginLeft: '2%' }}>
                                            {labelData.SalePrint.TotalAmount != null
                                                ? labelData.SalePrint.TotalAmount.toFixed(2)
                                                : '0.00'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <tbody>
                            <tr>
                                <td
                                    colSpan="12"
                                    style={{
                                        border: '1px solid black',
                                        padding: '2px 5px',
                                        height: '15px',
                                    }}
                                >
                                    <h6
                                        style={{
                                            margin: '5px',
                                            fontSize: '14px',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        <AmountInWords amount={labelData.SalePrint.TotalAmount} />
                                    </h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '50px', maxHeight: '20%', width: '68%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '70px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>HDFC BANK, Karukappilly Jn Br.</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>A/c No.00208630000292</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-13px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>IFSC : HDFC0006483</span></h6>

                                    {/* <img src={QRCODE} alt="QRCODE" style={{ maxHeight: '12%', margin: '0 auto', width: '30%', marginLeft: '37%', marginTop: '-120px' }} /> */}

                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '20px', marginTop: '-18%' }}>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>ICICI BANK , EDAPPALLY Br.</span></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>Current A/C NO.626405016551</span></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}><span style={{ fontWeight: 'normal' }}>IFSC : ICIC0006264</span></h6>
                                    </div>
                                </td>

                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '20%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', fontFamily: 'arial', fontWeight: 'normal' }}>Net Value</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>CGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>SGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>IGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>TCS @ 0.1%</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Freight Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Freight GST@</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Round Off</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Grand Total</h6>
                                </td>

                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '20%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-5px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.TaxableAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.CGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.SGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.IGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.TCS.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.FreightAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.FreightRate.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.RoundOff.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.TotalAmount.toFixed(2)}</h6>

                                </td>

                            </tr>

                        </tbody>
                    </table>

                    <table style={{ ...tableStyle, height: '5%' }}>
                        <tbody >
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, width: '17%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '15px', fontWeight: 'normal' }}>For {labelData.SalePrint.CompanyName}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '35px', fontWeight: 'normal' }}>Authorized Signatory</h6>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </>
            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default SaleReturnPrint;
